export const EDI_TOP_FILTER_API_STANDARD_SEARCH_URL = "standard-search/topfilter";
export const EDI_TOP_FILTER_API_CLAIM_SEARCH_URL = "claim-search/topfilter";
export const EDI_TOP_FILTER_API_EDI_URL = "edi-transaction-trend/topfilter";
export const EDI_TOP_FILTER_API_BULK_URL = "edi-transaction-trend-job/topfilter";
